"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agrupacionesStore = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createSuper"));

var _AgrupacionesApi = require("@/api/AgrupacionesApi");

var _NotifyUtils = require("@/utils/NotifyUtils");

var _index = require("./index");

var _LoaderStore = require("./LoaderStore");

var AgrupacionesStore = /*#__PURE__*/function (_Store) {
  (0, _inherits2.default)(AgrupacionesStore, _Store);

  var _super = (0, _createSuper2.default)(AgrupacionesStore);

  function AgrupacionesStore() {
    (0, _classCallCheck2.default)(this, AgrupacionesStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AgrupacionesStore, [{
    key: "data",
    value: function data() {
      return [];
    }
  }, {
    key: "loadAgrupaciones",
    value: function () {
      var _loadAgrupaciones = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _LoaderStore.loaderStore.setLoader({
                  loading: true
                });

                _context.t0 = this;
                _context.next = 5;
                return (0, _AgrupacionesApi.getData)();

              case 5:
                _context.t1 = _context.sent;

                _context.t0.setState.call(_context.t0, _context.t1);

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t2 = _context["catch"](0);
                (0, _NotifyUtils.notifyError)(_context.t2);

              case 12:
                _context.prev = 12;

                _LoaderStore.loaderStore.setLoader({
                  loading: false
                });

                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 12, 15]]);
      }));

      function loadAgrupaciones() {
        return _loadAgrupaciones.apply(this, arguments);
      }

      return loadAgrupaciones;
    }()
  }]);
  return AgrupacionesStore;
}(_index.Store);

var agrupacionesStore = new AgrupacionesStore();
exports.agrupacionesStore = agrupacionesStore;